import api from './client';
import ApiError from './error';

const AccountService = {
  async login({ email, password, deviceName }) {
    try {
      const client = await api.getClient();
      return client.authLogin(null, { email, password, device_name: deviceName });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async logout() {
    try {
      const client = await api.getClient();
      return client.authLogout();
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async passwordTokenCreate({ email }) {
    try {
      const client = await api.getClient();
      return client.passwordTokenCreate(null, { email });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async passwordTokenVerify({ email, code }) {
    try {
      const client = await api.getClient();
      return client.passwordTokenVerify(null, { email, code });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },

  async passwordTokenUpdate({
    email, code, deviceName, password, passwordConfirmation,
  }) {
    try {
      const client = await api.getClient();
      return client.passwordTokenUpdate(null, {
        email, code, device_name: deviceName, password, password_confirmation: passwordConfirmation,
      });
    }
    catch (e) {
      throw new ApiError(e);
    }
  },
};

export default AccountService;
